import React from "react";
import styled from "styled-components";
import { Comment } from "@sonder/ui/source/styled/fragments/Comment";
import { Link } from "@sonder/ui/source/styled/fragments/Link";
import { colors } from "@sonder/ui/source/styled/theme";

const StyledArchivedComment = styled(Comment)`
  background: ${colors.grayF};
  color: ${colors.grayA};
  justify-content: space-between;
`;

interface ArchivedCommentProps {
  onUndoArchive?(): void;
}
export const ArchivedComment = ({ onUndoArchive }: ArchivedCommentProps) => (
  <StyledArchivedComment>
    Your comment has been deleted from this thread
    {typeof onUndoArchive === "function" && (
      <Link
        onClick={e => {
          e.preventDefault();
          onUndoArchive();
        }}
      >
        Undo
      </Link>
    )}
  </StyledArchivedComment>
);
